import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Grid from '@material-ui/core/Grid';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import Field from 'core/components/form/form.v2';
import ValueField from 'core/components/value-field';
import useSession from 'core/hooks/use-session';

import useStyles from './policy-restrictions-card.styles';

const MAX_LENGTH = 1000;
const FIELD_LABEL = 'Underwriting policy restrictions description (optional)';
const PLACEHOLDER = 'Provide details about any restrictions related to this policy';

const PolicyRestrictionsCard = ({ variant }) => {
  const classes = useStyles({ variant });
  const isModal = variant === 'modal';
  const { canApproveUWReview } = useSession();
  const { values } = useFormikContext();
  const restrictions = values?.restrictions;

  if (!canApproveUWReview && !restrictions) {
    return null;
  }

  return (
    <Grid container className={classes.sectionContainer}>
      {!isModal && (
        <Label type="subtitle1" className={classes.sectionHeader}>
          Policy restrictions
        </Label>
      )}
      <Card className={classes.card}>
        {isModal && <Label className={classes.cardTitle}>Policy restrictions</Label>}
        {canApproveUWReview ? (
          <Field
            id="restrictions"
            name="restrictions"
            type="textarea"
            mode="light"
            label={FIELD_LABEL}
            placeholder={PLACEHOLDER}
            inputProps={{ maxLength: MAX_LENGTH }}
            rows={isModal ? 2 : undefined}
            className={classes.textareaField}
          />
        ) : (
          <ValueField label={FIELD_LABEL} value={restrictions} />
        )}
      </Card>
    </Grid>
  );
};

PolicyRestrictionsCard.propTypes = {
  variant: PropTypes.string
};

PolicyRestrictionsCard.defaultProps = {
  variant: undefined
};

export default PolicyRestrictionsCard;
